module.exports = __webpack_public_path__ + "static/media/provider-tool.59693443.jpg";